import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockHotelPricing2 = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelPricingRequest2.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelPricingResponse2.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingRequest2.xml'} title={t('Пример запроса') + ' ' + t('Безналичная оплата, тариф без питания')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingResponse2.xml'} title={t('Пример успешного ответа') + ' ' + t('Безналичная оплата, тариф без питания')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingRequest2-2.xml'} title={t('Пример запроса') + ' ' + t('Тариф с питанием')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingResponse2-2.xml'} title={t('Пример успешного ответа') + ' ' + t('Тариф с питанием')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingRequest2-3.xml'} title={t('Пример запроса') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingResponse2-3.xml'} title={t('Пример успешного ответа') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelPricingResponseError2.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockHotelPricing2;